import { APIRequestBase } from '@/models/api/models-api'

/**
 * Web-LINE会員証取得リクエストクラス
 * @class GetMembersCardRequest
 */
export class GetMembersCardRequest extends APIRequestBase {
    /**
     * @constructor
     */
    constructor(_provisionShopCode, _lineid, _brandsite) {
        super()

        this.provisionShopCode = _provisionShopCode
        this.lineid = _lineid
        this.brandsite = _brandsite
    }

    /** @type {string} */
    provisionShopCode = null
    /** @type {string} */
    lineid = null
    /** @type {string} */
    brandsite = null
}
